import createFetchInstance from '@bfe/by-fetch';
var httpOpts = {
  headers: {
    'Content-Type': 'application/json'
  }
};
var http = createFetchInstance(httpOpts);
export default http;